/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";

var FOLLOWERS_COUNT_SELECTOR = ".profile-counter--followers .profile-counter__count";

export default baustein.register("profile-header-counters", {
    updateFollowCounter: function(event, profileId) {
        var followedId = parseInt(event.target.followId, 10);

        // Return if we don't have a following count or
        // if the follow event doesn't belong to the profile itself
        if (!this._getFollowingCountEl() || profileId !== followedId) {
            return;
        }

        if (event.type === "userFollow") {
            this.increaseFollowCounter();
        } else if (event.type === "userUnfollow") {
            this.decreaseFollowCounter();
        }
    },

    increaseFollowCounter: function() {
        var count = this.getFollowCount();
        count++;

        this.setFollowCount(count);
    },

    decreaseFollowCounter: function() {
        var count = this.getFollowCount();
        count--;

        this.setFollowCount(count);
    },

    getFollowCount: function() {
        var followCountEl = this._getFollowingCountEl();
        // needed because we have thousands separators
        var followCount = followCountEl.innerHTML.replace(",", "");

        return parseInt(followCount);
    },

    setFollowCount: function(newValue) {
        var followCount = this._getFollowingCountEl();
        var newCount = this._addThousandsSeparators(newValue);

        followCount.innerHTML = newCount;
    },

    _addThousandsSeparators: function(number) {
        return Number(number).toLocaleString("en");
    },

    _getFollowingCountEl: function() {
        return this.el.querySelector(FOLLOWERS_COUNT_SELECTOR);
    }
});

